const Accordion = {
  el: {
    accordionItems: document.querySelectorAll<HTMLElement>('.accordion-item'),
  },
  options: {
    transitionDuration: 0.5,
  },

  init() {
    Array.prototype.forEach.call(this.el.accordionItems, (accordionItem) => {
      const head = accordionItem.querySelector('.accordion-item__head')
      head.addEventListener('click', this.toggleHead)

      head.addEventListener('keypress', (event) => {
        console.log(event.key)
        if (event.key === 'Enter') {
          event.preventDefault()
          this.toggleHead(event)
        }
      })
    })
  },

  toggleHead(event) {
    const accordionItem = event.currentTarget.parentElement
    const accordionItemIsSelected = accordionItem.classList.contains(
      'accordion-item--selected'
    )
    const accordion = accordionItem.parentElement

    if (!accordionItemIsSelected) {
      //close opened items
      const selectedItem = accordion.querySelector('.accordion-item--selected')
      if (selectedItem) Accordion.closeItem(selectedItem)
      // open the item
      Accordion.openItem(accordionItem)
    } else {
      // close current item (if it was opened)
      Accordion.closeItem(accordionItem)
    }
  },

  closeItem(accordionItem) {
    const accordion = document.querySelector('.accordion-block')
    const accordionBody = accordionItem.querySelector('.accordion-item__body')
    // get the height
    const accordionBodyHeight = accordionBody.getBoundingClientRect().height
    accordionItem.classList.remove('accordion-item--selected')
    // set inline height
    accordionBody.style.height = `${accordionBodyHeight}px`
    // zero the height (animate)
    setTimeout(() => {
      accordionBody.style.height = 0
      // remove inline height after the transition
      setTimeout(
        () => accordionBody.removeAttribute('style'),
        this.options.transitionDuration * 1000
      )
    }, 10)
    //remove classlist of siblings
    accordion.classList.remove('item-selected')
  },

  openItem(accordionItem) {
    const accordion = document.querySelector('.accordion-block')

    accordion.classList.add('item-selected')
    accordionItem.classList.add('accordion-item--selected')
    // get the height (after opened)
    const accordionBody = accordionItem.querySelector('.accordion-item__body')
    const accordionBodyHeight = accordionBody.getBoundingClientRect().height
    // immediately zero the height (don't open yet)
    accordionBody.style.height = 0
    // set inline height to animate
    setTimeout(() => {
      accordionBody.style.height = `${accordionBodyHeight}px`
      // remove inline height after the transition
      setTimeout(
        () => accordionBody.removeAttribute('style'),
        this.options.transitionDuration * 1000
      )
    }, 10)
  },
}

export default Accordion
